export enum DeedType {
  OBRAS_DIDATICAS = 1,
  OBRAS_PEDAGOGICAS = 2,
  OBRAS_LITERARIAS = 3,
}

// Fora de uso desde SPA-283 (EJA passou a ser Etapa, não Tipo de Obra).
// Mantido só para exibir processamentos criados antes da mudança — nunca
// usar nas opções do formulário de criação (o backend rejeita nu_deed_type=4).
export enum LegacyDeedType {
  OBRAS_EJA = 4,
}

export enum EducationStage {
  EDUCACAO_INFANTIL = 1,
  ENSINO_FUNDAMENTAL_ANOS_INICIAIS = 2,
  ENSINO_FUNDAMENTAL_ANOS_FINAIS = 3,
  ENSINO_MEDIO = 4,
  EJA = 5,
}

export enum Status {
  PENDENTE = 1,
  PROCESSANDO = 2,
  CONCLUIDO = 3,
  FALHOU = 4,
}

export interface Processing {
  coProcessing: number
  dsNotice: string | null
  // Um processamento vindo da API pode ter o valor legado (SPA-283), então
  // o tipo de leitura precisa cobrir os dois; a criação usa só DeedType.
  nuDeedType: DeedType | LegacyDeedType
  nuEducationStage: EducationStage
  stStatus: Status
  nuProgress: number
  dsErrorLog: string | null
  dtCreatedAt: string
  dtUpdatedAt: string
}

export interface ProcessingDetails extends Processing {
  requester: {
    coUser: number
    noUserName: string
    dsEmail: string
    dsCpf: string
  }
  noFileNameAdherenceReport: string
  noFileNameSelectionReport: string
  // PSV-424: nome original do Mapa de Atendimento; null sem mapa.
  noFileNameServiceMap?: string | null
  // PSV-426: mapa gravado E resultados ligados a ele. Ausente (backend
  // anterior à 426) vale como `false`.
  inHasServiceMap?: boolean
}

// PSV-426: colunas do Mapa de Atendimento nas listas. O backend só as envia
// quando o processamento tem mapa; sem mapa as chaves não existem.
export interface ServiceMapFields {
  dsCategory?: string | null
  dsArea?: string | null
  dsServedStages?: string | null
}

export interface ProcessingCollection extends ServiceMapFields {
  coCollectionProcessing: number
  noCollection: string
  dsCollectionCode: string
  dsPublisher: string
  dsComponent: string
  nuQuantityCensus: number
  nuQuantityQt1: number
  nuQuantityQt2: number
}

export interface ProcessingSchool extends ServiceMapFields {
  coSchoolProcessing: number
  noSchool: string
  dsSchoolInepCode: string
  dsSphere: string
  dsCity: string
  dsState: string
  dsYearGrade: string
  noCollection: string
  dsCollectionCode: string
  dsPublisher: string
  dsComponent: string
  nuQuantityCensus: number
  nuQuantityQt1: number
  nuQuantityQt2: number
  // PSV-282/PSV-287: escola optou por não receber o componente (código de
  // coleção 000000000). Quantidades já vêm zeradas do backend nesse caso.
  inOptedOut: boolean
}
